var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanItemRow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BADGE_GARANTIA",
    "data-name": "BADGE GARANTIA",
    transform: "translate(-1008 -224)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(1011 227)",
    fill: "#858a96",
    opacity: 0.241
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    transform: "translate(1008 224)",
    fill: "none",
    stroke: "#404757",
    strokeWidth: 2,
    opacity: 0.787
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trophy_film",
    "data-name": "Trophy film",
    transform: "translate(1021 240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M20,43a3.5,3.5,0,0,0,3.5-3.5V37h5v2.5A3.5,3.5,0,0,0,32,43Z",
    transform: "translate(-7 -18.5)",
    fill: "#858a96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M15,52v-.5A2.5,2.5,0,0,1,17.5,49h12A2.5,2.5,0,0,1,32,51.5V52Z",
    transform: "translate(-4.5 -24.5)",
    fill: "#fef2ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1731",
    "data-name": "Rectangle 1731",
    width: 25.143,
    height: 17.714,
    rx: 2,
    transform: "translate(6.714 0.571)",
    fill: "#fef2ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M7,5V2A1,1,0,0,1,8,1H31a1,1,0,0,1,1,1V5Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#858a96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M7,5V2A1,1,0,0,1,8,1h2.5V5Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#fef2ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M30.5,0H7.5A1.5,1.5,0,0,0,6,1.5v16A1.5,1.5,0,0,0,7.5,19H16v2a3,3,0,0,1-3,3,3,3,0,0,0-3,3H8a.5.5,0,0,0-.5.5v4A.5.5,0,0,0,8,32H30a.5.5,0,0,0,.5-.5v-4A.5.5,0,0,0,30,27H28a3,3,0,0,0-3-3,3,3,0,0,1-3-3V19h8.5A1.5,1.5,0,0,0,32,17.5V1.5A1.5,1.5,0,0,0,30.5,0ZM31,1.5V4H28.426l1.387-1.11a.5.5,0,0,0,0-.781L28.426,1H30.5a.5.5,0,0,1,.5.5ZM25.425,4l1.387-1.11a.5.5,0,0,0,0-.781L25.425,1h1.4L28.7,2.5,26.824,4Zm-3,0,1.387-1.11a.5.5,0,0,0,0-.781L22.426,1h1.4L25.7,2.5,23.824,4Zm-3,0,1.387-1.11a.5.5,0,0,0,0-.781l-.457-.366L19.425,1h1.4L22.7,2.5,20.824,4Zm-3,0,1.387-1.11a.5.5,0,0,0,0-.781L16.425,1h1.4L19.7,2.5,17.825,4Zm-3,0,1.387-1.11a.5.5,0,0,0,0-.781L13.425,1h1.4L16.7,2.5,14.825,4ZM10.5,4V1h1.325L13.7,2.5,11.825,4ZM7,1.5A.5.5,0,0,1,7.5,1h2V4H7ZM29.5,28v3H8.5V28ZM27,27H11a2,2,0,0,1,2-2H25A2,2,0,0,1,27,27Zm-4.643-3H15.643A3.992,3.992,0,0,0,17,21V19h4v2a3.992,3.992,0,0,0,1.357,3ZM30.5,18H7.5a.5.5,0,0,1-.5-.5V5H31V17.5A.5.5,0,0,1,30.5,18Z",
    fill: "#404757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M31.5,14a.5.5,0,0,0,0-1h-18a.5.5,0,0,0,0,1H19v2H13.5a.5.5,0,0,0,0,1h18a.5.5,0,0,0,0-1H26V14ZM20,14h5v2H20Z",
    transform: "translate(-3.5 -6.5)",
    fill: "#404757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M31.5,23h-18a.5.5,0,0,0,0,1h18a.5.5,0,0,0,0-1Z",
    transform: "translate(-3.5 -11.5)",
    fill: "#404757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M13.5,28H21a.5.5,0,0,0,0-1H13.5a.5.5,0,0,0,0,1Z",
    transform: "translate(-3.5 -13.5)",
    fill: "#404757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M26.5,31h-13a.5.5,0,1,0,0,1h13a.5.5,0,1,0,0-1Z",
    transform: "translate(-3.5 -15.5)",
    fill: "#404757"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanItemRow2);
export default __webpack_public_path__ + "static/media/plan-item-row2.58a920c9491254984a6b1b80c3feef41.svg";
export { ForwardRef as ReactComponent };